export default __webpack_public_path__ + "static/B0184-469e1f19496fddd93bc9e6431ad7f31d.png";